module.exports = __webpack_public_path__ + "assets/36086a76813eb47e901f611e58990a6b.png";